module.exports = __webpack_public_path__ + "img/b2.df9695e8.png";